const { lazy } = require("react");

const Dashboard = lazy(() => import("../screens/Dashboard/index"));
const Faqs = lazy(() => import("../screens/Dashboard/Faqs"));
const Ticket = lazy(() => import("../screens/Dashboard/Ticket"));
const Privacy = lazy(() => import("../screens/Dashboard/Privacy"));
const Routes = lazy(() => import("../screens/Dashboard/Routes"));
const Refunds = lazy(() => import("../screens/Dashboard/Refunds"));
const Referral = lazy(() => import("../screens/Dashboard/Referral"));
const ReferralDashboard = lazy(() => import("../screens/Dashboard/ReferralDashboard"));

const routes = [
  {
    path: "/",
    exact: true,
    component: Dashboard,
    name: "Dashboard",
  },
  {
    path: "/tickets/history",
    exact: true,
    component: Ticket,
    name: "Ticket",
  },
  {
    path: "/rcpt",
    exact: true,
    component: Ticket,
    name: "Ticket",
  },
  {
    path: "/faqs",
    exact: true,
    component: Faqs,
    name: "Faqs",
  },
  {
    path: "/terms",
    exact: true,
    component: Privacy,
    name: "Privacy",
  },
  {
    path: "/routes",
    exact: true,
    component: Routes,
    name: "Routes",
  },
  {
    path: "/refunds",
    exact: true,
    component: Refunds,
    name: "Refunds",
  },
  {
    path: "/referral",
    exact: true,
    component: Referral,
    name: "Referral",
  },
  {
    path: "/referral-dashboard",
    exact: true,
    component: ReferralDashboard,
    name: "ReferralDashboard",
  },
];

export default routes;
